<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'bcContestPreferences_title' | translate}}</h4>
</div>

<div class="modal-body">
    <form #form="ngForm">
        <table class="table">
            <thead>
                <tr>
                    <th>{{'bcContestPreferences_lblPriority' | translate}}</th>
                    <th>{{'bcContestPreferences_lblCourse' | translate}}</th>
                    <th>{{'bcContestPreferences_lblCreditPoints' | translate}}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let c of courses; let i = index" [class.row-removed]="isRemoved(c)">
                    <td>{{i + 1}}</td>
                    <td>
                        <div class="text-top">{{c.SubjectCode}}</div>
                        <div>{{c.Subject}}</div>
                        <div class="mt-1 course-status text-sub">
                            <span>{{'bcContestApply_lblApplicantCount' | translate}}: {{c.ApplicationCount}}</span>
                            <app-bc-contest-probability [value]="c.Probability"></app-bc-contest-probability>
                        </div>
                    </td>
                    <td>{{c.CreditPoints | number:'1.0-2'}}</td>
                    <td>
                        <div class="table-actions">
                            <button type="button" class="btn btn-outline btn-icon" (click)="up(c)" [disabled]="i == 0 || isRemoved(c)">
                                <i class="fi fi-rs-angle-up"></i>
                            </button>

                            <button type="button" class="btn btn-outline btn-icon" (click)="down(c)" [disabled]="i == courses.length - 1 || isRemoved(c)">
                                <i class="fi fi-rs-angle-down"></i>
                            </button>

                            <button type="button" class="btn btn-outline-primary btn-icon" (click)="toggle(c)">
                                <i class="fi fi-rs-trash" *ngIf="!isRemoved(c); else addBack"></i>
                                <ng-template #addBack>
                                    <i class="fi fi-rs-undo"></i>
                                </ng-template>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </form>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="close()" type="button">{{'dialog_close' | translate}}</button>

    <button class="btn btn-primary" (click)="save()" type="button" [disabled]="isSaving || !form.valid || !courses.length">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSaving"></span>
        {{'save' | translate}}
    </button>
</div>
